import React, { forwardRef } from "react";

const Input = forwardRef(
  ({ label, error, icon, darkMode = true,className = "", containerClassName = "", ...props }, ref) => {
    return (
      <div className={containerClassName}>
        {label && (
          <label
  className={`block text-sm font-medium mb-2 ${
    darkMode ? "text-slate-300" : "text-slate-700"
  }`}
>
            {label}
          </label>
        )}

        <div className="relative">
          {icon && (
            <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400">
              {icon}
            </div>
          )}

          <input
            ref={ref}
            {...props}
            className={`
  w-full px-4 py-2.5 rounded-2xl
  ${
    darkMode
      ? "bg-white/[0.04] border border-white/10 text-white placeholder:text-slate-400 hover:border-white/20 focus:bg-white/[0.06]"
      : "bg-white border border-slate-300 text-slate-900 placeholder:text-slate-800 hover:border-slate-400 focus:bg-white"
  }
  outline-none
  transition-all duration-200
  focus:border-cyan-500
  focus:ring-4 focus:ring-cyan-500/10
  disabled:opacity-50 disabled:cursor-not-allowed
  ${icon ? "pl-11" : ""}
  ${error ? "border-rose-500/70 focus:ring-rose-500/15" : ""}
  ${className}
`}
          />

          {error && <p className="mt-2 text-sm text-rose-400">{error}</p>}
        </div>
      </div>
    );
  }
);

Input.displayName = "Input";

export default Input;
